import { requestLaravel } from '../../../../utils/api'
import { ApiResponse } from '../../core/_models'
import { PermissionsPayload } from './permissions'

export function getProfileAPI(): Promise<ApiResponse<{ permissions?: PermissionsPayload }>> {
  return requestLaravel<ApiResponse<{ permissions?: PermissionsPayload }>>('/profile')
}
